import { render } from "./RecutTracker.vue?vue&type=template&id=5d4e6cb1"
import script from "./RecutTracker.vue?vue&type=script&lang=js"
export * from "./RecutTracker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__